import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const { t } = useTranslation("home");

  return (
    <section className="relative w-full min-h-screen flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20minimalist%20fashion%20editorial%20scene%20with%20warm%20cream%20and%20soft%20beige%20textured%20backdrop%2C%20carefully%20styled%20modern%20apparel%20and%20accessories%20arranged%20on%20clean%20surface%2C%20natural%20daylight%20from%20large%20window%2C%20airy%20atmosphere%2C%20high%20end%20product%20photography%2C%20soft%20organic%20shadows%2C%20harmonious%20warm%20neutral%20color%20palette%2C%20lifestyle%20composition&width=1800&height=1100&seq=hero-main-v2-001&orientation=landscape"
          alt="USFansSpreadsheet - Kompletny przewodnik"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      <div className="relative z-10 w-full px-4 md:px-6 pt-20">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-white leading-[1.05] tracking-tight">
            {t("heroTitle1")}
            <br />
            {t("heroTitle2")}
            <br />
            <span className="text-accent-300">{t("heroTitle3")}</span>
          </h1>
          <p className="mt-6 text-base md:text-lg text-white/80 max-w-xl leading-relaxed">
            {t("heroSubtitle")}
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 bg-white text-foreground-950 px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-white/90 transition-all whitespace-nowrap cursor-pointer"
            >
              {t("heroTitle1")}
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
            <Link
              to="/artykul/usfansspreadsheet-poradnik-2026"
              className="inline-flex items-center justify-center gap-2 bg-foreground-950 text-white px-7 py-3.5 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              {t("viewGuide")}
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}